import { booleanAttribute } from "#ce/utils/props";

// Props only the provider card declares, so a deployment default for them reaches no location card.
export const props = Object.freeze({
  /**
   * Shows the number of ratings under the stars: "45 Ratings". A deployment sets it for every provider card through its
   * `ui/components.yml` defaults.
   *
   * @type {Boolean|String}
   * @default false
   */
  showratingcount: booleanAttribute(),
  /**
   * The provider's other locations, shown below the card in the bio layout: `{ count, expanded, status, results }`.
   * The result view sets it when its directory folds other locations out; without it the card links to the profile's
   * locations. Set as a DOM property, not an attribute.
   *
   * @type {Object}
   * @storybook-control object
   * @default undefined
   */
  otherLocations: {
    type: Object,
    default: undefined,
  },
});
